import { useMediaQuery } from "react-responsive";

function useMediaQueries() {
  const isSmallScreen = useMediaQuery({ query: "(max-width: 600px)" });
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  return {
    isSmallScreen,
    isDesktopOrLaptop,
  };
}

export default useMediaQueries;
